export enum DataSourceType {
  notion = 'notion',
  website = 'website',
}
